import { CircleCrossIcon, MoneyAddIcon, MoneyBackIcon, RosterIcon, ShapesIcon } from "@xola/icons";
import { canCancel, PurchaseActionOption } from "common";
import React from "react";
import { MerchandisePurchaseItem, Permission, Purchase } from "types";
import { IsGranted } from "@/components/Common/IsGranted";
import { Menu } from "@/components/Common/Menu";

interface MerchandiseMenuItemsProps {
    purchase: Purchase;
    item: MerchandisePurchaseItem;
    isOrganizer: boolean;
    onButtonClick: (action: PurchaseActionOption) => void;
}

export const MerchandiseMenuItems = ({ purchase, item, isOrganizer, onButtonClick }: MerchandiseMenuItemsProps) => {
    const isItemCancellable = canCancel(item);

    return (
        <>
            {isOrganizer && (
                <Menu.Item
                    icon={<RosterIcon />}
                    onClick={async () => onButtonClick(PurchaseActionOption.ADD_PURCHASE_NOTE)}
                >
                    Add Purchase Note
                </Menu.Item>
            )}

            <Menu.Item
                icon={<ShapesIcon />}
                isDisabled={!isItemCancellable}
                onClick={async () => onButtonClick(PurchaseActionOption.UPDATE_QUANTITY)}
            >
                Modify Purchase
            </Menu.Item>

            <Menu.Item icon={<MoneyAddIcon />} onClick={async () => onButtonClick(PurchaseActionOption.CHARGE)}>
                Charge
            </Menu.Item>

            {purchase.amount > 0 && (
                <IsGranted permissions={Permission.REFUND_AMOUNT}>
                    <Menu.Item
                        icon={<MoneyBackIcon />}
                        onClick={async () => onButtonClick(PurchaseActionOption.REFUND)}
                    >
                        Refund
                    </Menu.Item>
                </IsGranted>
            )}

            <IsGranted permissions={Permission.MODIFY_BOOKING_LITE}>
                <Menu.Item
                    icon={<CircleCrossIcon />}
                    isDisabled={!isItemCancellable}
                    onClick={async () => onButtonClick(PurchaseActionOption.CANCEL_RESERVATION)}
                >
                    Cancel Purchase
                </Menu.Item>
            </IsGranted>
        </>
    );
};
